<template>

    <f7-block
        :style="`margin-top: -20px; padding-bottom: 100px; z-index: 11; background-color: #0A3020;`"
        :key="`homebloc-${course.id}`"
        class="homeBlockWrapper"
    >
        <!-- ${topicsIndex[course.topicId] && variant === 0 ? topicsIndex[course.topicId].color : '#0A3020'}; background-image:url('${topicsIndex[course.topicId] && topicsIndex[course.topicId].data && course.id !== 223 && variant !== 3 ? topicsIndex[course.topicId].data.imageUrl : ''}'); background-size: 1500px 100px; background-position: -${courseTopicIndex(course) * 240}px bottom; background-repeat: repeat-x; -->
        <f7-block-title
            v-if="onboardingCompleted > 1 && progress.length"
            style="margin: 0 0px; padding-top: 16px; font-weight: 300; line-height: 20px; color: white"
        >RESUME</f7-block-title>
        <br v-else>
        <h2>{{ course.name || '' }}</h2>
        <div
            class="courseDescription"
            v-html="stripTags(course.description || topicsIndex[course.topicId] ? topicsIndex[course.topicId].name : '')"
        />

        <f7-block
            :key="`course-${user.currentCourseId}-pack-0`"
            class="homeBlock"
        >
            <sequential-entrance
                v-if="unitsByPack[0] && unitsByPack[0].length"
                from-bottom
                delay="400"
            >
                <template v-for="(unit, i) in unitsByPack[0]">
                    <unit-card
                        :unit="unit"
                        :key="`notir-${unit.id}`"
                        :visible="true"
                        :is-learn="true"
                        :home="true"
                        :class="`${getIsLastOne(i,0) ? 'last' : ''}`"
                        :disabled="isDisabledOnHome(unit)"
                        :color="topicsIndex[course.topicId].color"
                        :index="i"
                        :pack="unitsByPack[0]"
                    />
                </template>
            </sequential-entrance>

            <f7-link
                v-if="hiddenUnits.length && course.topicId !== 16"
                class="moreLink"
                @click="toggleHidden"
            >{{ showHidden ? 'Hide' : 'Show' }} hidden units</f7-link>
            <br
                v-if="showHidden"
                style="clear: both"
            >
            <div v-if="hiddenUnits.length && showHidden">
                <div style="color: #686868; margin-top: 0px; margin-bottom: 0px; padding: 10px">
                    These units have been hidden because they are not relevant to your gender, sexual preference, relationship status or other traits. You can edit your traits in Settings.
                </div>
                <sequential-entrance from-bottom>
                    <template v-for="(unit, i) in hiddenUnits">
                        <unit-card
                            :unit="unit"
                            :key="`hidden-home-${unit.id}`"
                            :color="topicsIndex[course.topicId].color"
                            :visible="true"
                            :index="i"
                            :home="true"
                            :pack="hiddenUnits"
                        />
                    </template>
                </sequential-entrance>
            </div>
        </f7-block>

        <template v-for="(pack) in course.packs">
            <h2
                v-if="unitsByPack[pack.id] && unitsByPack[pack.id].length"
                :key="`course-${user.currentCourseId}-pack-${pack.id}-divider`"
            ><br>
                {{ pack.title }}<br>
                <span style="font-size: 16px;">{{ pack.subtitle }}</span><br>
            </h2>
            <f7-block
                v-if="unitsByPack[pack.id] && unitsByPack[pack.id].length"
                :key="`course-${user.currentCourseId}-pack-${pack.id}`"
                class="homeBlock"
            >
                <sequential-entrance
                    from-bottom
                    delay="400"
                >
                    <template v-for="(unit, i) in unitsByPack[pack.id]">
                        <unit-card
                            :unit="unit"
                            :key="`notir2-${unit.id}`"
                            :home="true"
                            :is-learn="true"
                            :color="topicsIndex[course.topicId].color"
                            :disabled="isDisabledOnHome(unit)"
                            :index="i"
                            :pack="unitsByPack[pack.id]"
                        />
                    </template>
                </sequential-entrance>
            </f7-block>
        </template>

        <!-- <p class="center">
                    <f7-link
                        v-if="onboardingCompleted > 1 && loaded"
                        :href="`/courses/${user.currentCourseId}/nextUp?fromHome=1`"
                        class="nextLink"
                    >SEE WHAT'S NEXT</f7-link>
                    <br v-else>
                </p> -->

    </f7-block>

</template>

<script>
import _ from 'lodash';

import utils from '../../js/utils';

import UnitCard from '../../components/unitCard.vue';
import {
    BEGIN_THE_REVOLUTION,
    CHANGE_YOUR_LIFE_IDS,
} from '../../js/constants';

export default {
    components: {
        UnitCard,
    },
    props: ['variant', 'course'],
    store: [
        'api',
        'user',
        'myTopics',
        'topicsIndex',
        'unitsIndex',
        'onboardingCompleted',
        'progress',
        'currentCourse',
        'myTraits'
    ],
    data () {
        return {
            unitsByPack: [],
            hiddenUnitsByPack: [],
            shownUnits: 0,
            showHidden: false,
            hiddenUnits: [],
        };
    },
    watch: {
        currentCourse: function () {
            if (['learn', 'goal'].indexOf(this.currentCourse.type) > -1 &&
                this.currentCourse &&
                this.course.id !== this.currentCourse.id) {
                this.course = this.currentCourse;
            }
        }
    },
    mounted: function () {
        this.getUnits();
    },
    methods: {
        toggleHidden: function () {
            this.showHidden = !this.showHidden;
            this.$events.fire('trackEvent', `show_hidden`, 'ui', this.course.id, 'unit', this.course);
        },
        getUnits: function (append) {
            if (!append) this.loaded = false;
            this.showLoadMore = false;
            const loadPacks = () => {
                this.shownUnits = 0;
                this.hiddenUnits = [];
                this.hiddenUnitsByPack = [];
                if (this.course && this.course.packs) {
                    for (let i = 0; i < this.course.packs.length; i++) {
                        this.unitsByPack[this.course.packs[i].id] = [];
                        this.hiddenUnitsByPack[this.course.packs[i].id] = 0;
                    }
                }
                this.unitsByPack[0] = [];
                this.hiddenUnitsByPack[0] = 0;
                if (!this.course || !this.course.units) return window.location.reload();
                for (let i = 0; i < this.course.units.length; i++) {
                    let unit = this.unitsIndex[this.course.units[i].id];
                    if (!unit) unit = this.course.units[i];
                    unit.position = 0;
                    if (unit.courses) {
                        for (let j = 0; j < unit.courses.length; j++) {
                            const element = unit.courses[j];
                            if (this.course && this.course.id === element.courseId) {
                                unit.packId = unit.courses[j].packId;
                                unit.position = unit.courses[j].position;
                            }
                        }
                    }
                    if (this.course.type !== 'learn' && this.course.type !== 'goal') unit.packId = 0;
                    if (!unit.packId) unit.packId = 0;
                    if (!this.unitsByPack[unit.packId]) this.unitsByPack[unit.packId] = [];
                    if (!this.checkTraits(unit)) {
                        this.hiddenUnits.push(unit);
                        this.hiddenUnitsByPack[unit.packId]++;
                    } else {
                        this.unitsByPack[unit.packId].push(unit);
                        this.shownUnits++;
                    }
                }
                for (let i = 0; i < this.unitsByPack.length; i++) {
                    this.unitsByPack[i] = _.sortBy(this.unitsByPack[i], [
                        (unit) => {
                            return unit.position;
                        },
                    ]);
                }

            };
            if (!append) loadPacks(this.course.units);
            if (append || !this.course.units.length) {
                let sort = ['listen', 'ask', 'play', 'blog'].indexOf(this.course.type) > -1 ? 'recent' : '';
                this.$http.get(`${this.api}/courses/${this.course.id}/units?sort=${sort}&offset=${append ? this.course.units.length : 0}`).then(
                    response => {
                        if (append) {
                            this.course.units = this.course.units.concat(response.body);
                        } else {
                            this.course.units = response.body || [];
                        }
                        this.loaded = true;
                        this.isLoading = false;
                        loadPacks(this.course.units);
                        if (response.body.length > 19) this.showLoadMore = true;
                    },
                    response => {
                        console.error(response.body.message || 'Unknown error 1104');
                        utils.failedRequest('main', response);
                    }
                );
            } else {
                this.loaded = true;
                this.isLoading = false;
            }
        },
        stripTags: function (text) {
            return text.replace(/<[^>]*>?/gm, '');
        },
        courseTopicIndex: function (course) {
            if (!this.topicsIndex[course.topicId] || !this.topicsIndex[course.topicId].courses) return 0;
            for (let i = 0; i < this.topicsIndex[course.topicId].courses.length; i++) {
                const element = this.topicsIndex[course.topicId].courses[i];
                if (element.id === this.course.id) return i;
            }
            return 0;
        },
        getIsLastOne: function (i, packId) {
            // console.log(i + 1, this.unitsByPack[packId].length - this.hiddenUnitsByPack[packId])
            return i + 1 === this.unitsByPack[packId].length - this.hiddenUnitsByPack[packId];
        },
        isDisabledOnHome: function (unit) {
            // console.log('isDisabledOnHome', unit.id, this.onboardingCompleted)
            if (unit.id === BEGIN_THE_REVOLUTION) return false;
            if (this.onboardingCompleted == 1 && CHANGE_YOUR_LIFE_IDS.includes(unit.id) ) return false;
            if (this.onboardingCompleted < 2) return true;
            return false;
        },
        checkTraits: function (unit) {
            return utils.checkTraits(this.myTraits, unit);
        },
    }
};
</script>

<style lang="less" scoped>
@import '../../css/colors.less';

.center {
    text-align: center;
}
h2 {
    color: white;
    position: relative;
    z-index: 15;
    text-align: left;
    font-family: Editor-Bold;
    font-size: 21px;
    line-height: 26px;
    margin: 0 0 8px;
}
.blockTitle {
    margin-left: 0;
    color: white;
    font-family: AndesMedium;
    font-style: normal;
    font-weight: 300;
    font-size: 15px;
    line-height: 15px;
    z-index: 15;
    position: relative;
    margin-bottom: 4px;
}
.courseDescription {
    margin-top: -4px;
    color: white;
    font-family: AndesLight;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 14px;
    padding-bottom: 12px;
    z-index: 15;
    position: relative;
}
.moreLink {
    font-family: AndesMedium;
    text-transform: uppercase;
    line-height: 44px;
    color: #d9ccc4;
}
.nextLink {
    color: white;
    font-family: AndesMedium;
    text-transform: uppercase;
    line-height: 64px;
    z-index: 15px;
    position: relative;
    z-index: 16;
}
.home-scroll {
    margin-top: -100px !important;
    padding-top: 100px !important;
    height: ~'calc(100% + 100px)' !important;
    max-height: ~'calc(100% + 200px)' !important;
}
.homeBlockWrapper {
    text-align: left;
    transition: background-color 1s;
    color: white;
    background-size: 100% auto;
    background-position: bottom left;
    background-repeat: no-repeat;
    margin-bottom: 0px;
    padding-bottom: 20px;
}
.homeBlock {
    max-width: 100vw;
    background: white;
    padding: 0px;
    margin: 0px 0px 0px;
    border-radius: 13px;
    z-index: 15;
    position: relative;
}
.theme-dark .homeBlock {
    background: @black;
}
</style>
